import RichTextToolbar from './RichTextToolbar'
export default RichTextToolbar
